module.exports = __webpack_public_path__ + "static/media/educationPage.d74955a4.jpg";